<template>
  <v-container class="fill-height">
    <v-row justify="center">
      <v-alert type="warning" colored-border border="top" prominent>
        <div class="text-h4 mb-4">
          {{ $t("account-inactive-title") }}
        </div>
        <p style="white-space: pre-wrap">
          {{ $t("account-inactive-text") }}
        </p>
        <div class="text-center">
          <v-btn color="warning" outlined :to="{ name: 'Support' }">{{
            $t("Support")
          }}</v-btn>
        </div>
      </v-alert>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "InactiveReseller",
};
</script>